import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { DENTIFIQUE_CONTENT } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const DentifiqueSection = () => {
  return (
    <section id="dentifique" className="py-24 bg-gradient-to-br from-brand-900 to-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            <motion.div className="flex items-center space-x-2 mb-4" variants={fadeInUp}>
              <Sparkles size={18} className="text-accent-teal" />
              <span className="text-accent-teal-light text-sm font-semibold uppercase tracking-wider">
                {DENTIFIQUE_CONTENT.subtitle}
              </span>
            </motion.div>
            <motion.h2
              className="text-3xl sm:text-4xl mb-6 leading-tight"
              style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
              variants={fadeInUp}
            >
              {DENTIFIQUE_CONTENT.heading}
            </motion.h2>
            <motion.p
              className="text-neutral-300 text-lg leading-relaxed mb-8"
              style={{ fontFamily: "'Livvic', sans-serif" }}
              variants={fadeInUp}
            >
              {DENTIFIQUE_CONTENT.text}
            </motion.p>
            <motion.button
              className="inline-flex items-center space-x-2 bg-accent-teal text-white px-6 py-3 rounded-lg font-medium text-sm hover:bg-accent-teal-light transition-colors"
              variants={fadeInUp}
              whileHover={{ x: 5 }}
            >
              <span>{DENTIFIQUE_CONTENT.buttonText}</span>
              <ArrowRight size={16} />
            </motion.button>
          </motion.div>

          {/* Right - Features */}
          <motion.div
            className="space-y-4"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            <p className="text-white/80 text-sm font-semibold uppercase tracking-wider mb-2">
              Together, we provide:
            </p>
            {DENTIFIQUE_CONTENT.features.map((feature, i) => (
              <motion.div
                key={i}
                className="flex items-center space-x-4 bg-white/5 border border-white/10 rounded-xl px-6 py-4"
                variants={staggerItem}
              >
                <div className="w-8 h-8 bg-accent-teal/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-teal-light font-bold text-sm">{i + 1}</span>
                </div>
                <span className="text-white/90 font-medium" style={{ fontFamily: "'Livvic', sans-serif" }}>{feature}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DentifiqueSection;